import script from "./Campaigns.vue?vue&type=script&setup=true&lang=js"
export * from "./Campaigns.vue?vue&type=script&setup=true&lang=js"

import "./Campaigns.vue?vue&type=style&index=0&id=025524c0&scoped=true&lang=css"

import exportComponent from "/home/harris/Projects/cspd.com.cy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-025524c0"]])

export default __exports__